import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';

import EnhancedTab from '../../lib/designSystem/TabSimulation';
import {
  validateCompanyTypes,
  validatePermissions,
} from '../../lib/functions/utils';
import { AuthState } from '../../services/redux/authSlice';
import Companies from './components/Businesses';
import PausedAccounts from './components/Paused';
import SuspendedAccounts from './components/Suspended';
import TemporaryBusinesses from './components/TemporaryBusinesses';

const companyTabsAvailable = {
  added: {
    label: 'Activas',
    component: <Companies />,
    path: 'added',
    index: 0,
  },
  suspended: {
    label: 'Por Eliminar',
    component: <SuspendedAccounts />,
    path: 'suspended',
    index: 1,
  },
  paused: {
    label: 'Eliminadas',
    component: <PausedAccounts />,
    path: 'deleted',
    index: 2,
  },
  temporary: {
    label: 'Compartidas',
    component: <TemporaryBusinesses />,
    path: 'shared',
    index: 3,
  },
};

const MyAccounts: React.FC = () => {
  const user = useSelector((state: { auth: AuthState }) => state.auth.user);
  const { page } = useParams<{ page: string }>();
  const navigate = useNavigate();
  const [compnayTabs, setCompanyTabs] = useState<
    (typeof companyTabsAvailable)[keyof typeof companyTabsAvailable][]
  >([companyTabsAvailable.added]);

  const handleNavigation = (index: number) => {
    navigate(`/companies/${compnayTabs[index].path}`);
  };
  let startValue = compnayTabs.findIndex((x) => x.path === page);
  if (startValue === -1) startValue = 0;

  const setUp = async () => {
    const canManagePaused = validatePermissions(
      user,
      'manage_paused_businesses',
    );
    const newCompanyTabs: (typeof companyTabsAvailable)[keyof typeof companyTabsAvailable][] =
      [];

    newCompanyTabs.push(companyTabsAvailable.added);
    newCompanyTabs.push(companyTabsAvailable.suspended);

    if (canManagePaused) {
      newCompanyTabs.push(companyTabsAvailable.paused);
    }
    if (validateCompanyTypes(user, 'Fund')) {
      newCompanyTabs.push(companyTabsAvailable.temporary);
    }
    // if (validateCompanyTypes(user, 'Factoring')) {
    //   if (validatePermissions(user, 'financial_states_update_configuration'))  {
    //     newCompanyTabs.push({ label: 'Balances ', component: <FinancialStatementsSettings />, path: 'financialStatements', index: 0})
    //   }
    // }
    setCompanyTabs(newCompanyTabs);
  };

  useEffect(() => {
    void setUp();
  }, [user]);

  return (
    <div>
      <EnhancedTab
        title="Mis cuentas"
        startValue={startValue}
        tabs={compnayTabs}
        onTabChange={handleNavigation}
      />
    </div>
  );
};

export default MyAccounts;
